var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPoiMarkerActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 40,
    viewBox: "0 0 26 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.1,
    d: "M13 38.5C15.4853 38.5 17.5 37.8284 17.5 37C17.5 36.1716 15.4853 35.5 13 35.5C10.5147 35.5 8.5 36.1716 8.5 37C8.5 37.8284 10.5147 38.5 13 38.5Z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    opacity: 0.05,
    d: "M13 35.5C15.49 35.5 17.5 36.17 17.5 37C17.5 37.83 15.49 38.5 13 38.5C10.51 38.5 8.5 37.83 8.5 37C8.5 36.17 10.51 35.5 13 35.5ZM13 34C10.1 34 7 34.79 7 37C7 39.21 10.1 40 13 40C15.9 40 19 39.21 19 37C19 34.79 15.9 34 13 34Z",
    fill: "#212121"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.14 36.5C10.79 31.45 8.11 27.9 5.73 24.77C2.92 21.06 0.5 17.85 0.5 13C0.5 6.11 6.11 0.5 13 0.5C19.89 0.5 25.5 6.11 25.5 13C25.5 17.85 23.08 21.06 20.27 24.77C17.9 27.91 15.21 31.45 13.86 36.5H12.13H12.14Z",
    fill: "#FF5F50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M13 1C19.62 1 25 6.38 25 13C25 17.69 22.62 20.83 19.87 24.46C17.53 27.56 14.88 31.05 13.48 36H12.52C11.12 31.05 8.48 27.56 6.13 24.46C3.38 20.82 1 17.68 1 13C1 6.38 6.38 1 13 1ZM13 0C5.82 0 0 5.82 0 13C0 22.45 9 26 11.75 37H14.25C17 26 26 22.45 26 13C26 5.82 20.18 0 13 0Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M13 17.75C15.6234 17.75 17.75 15.6234 17.75 13C17.75 10.3766 15.6234 8.25 13 8.25C10.3766 8.25 8.25 10.3766 8.25 13C8.25 15.6234 10.3766 17.75 13 17.75Z",
    fill: "white"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoiMarkerActive);
export default __webpack_public_path__ + "static/media/poi_marker_active.48d7903b18cfffce5245855ee8f3bc83.svg";
export { ForwardRef as ReactComponent };